import apis from "../../config/apis.json";
import { getAccessToken } from "../msal";
import { IPublicClientApplication } from "@azure/msal-browser";
import axios from "axios";
import { IApp } from "./interfaces";
import { QueryString } from "lib/common/query-string";
import { IGetAppsRequest } from "./interfaces";

/**
 * Retrieves a list of apps.
 * The user must have the `view_apps` permission to access this endpoint.
 *
 * @param instance The msal instance.
 * @returns The retrieved users.
 */
export async function getApps(instance: IPublicClientApplication, request: IGetAppsRequest): Promise<IApp[]> {
  const { scope, baseUrl } = apis.security;

  const queryString = QueryString.from(request.queryParams);
  const requestUrl = `${baseUrl}/apps${queryString}`;
  const accessToken = await getAccessToken(instance, scope);

  const result = await axios.get(
    requestUrl, {
      headers: {
        "Authorization": `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      }
    });

  return result.data;
}
